module.exports = __webpack_public_path__ + "img/success.ff7b2c5b.png";